import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Roles } from "../../../../mp-utils/generic-utils"
import { Context, Transitions } from "../../types"

export const initOrgFilterState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  on: {
    // Pick which starting tab it should start at - different for each user role
    INIT_ORG_FILTER: [
      {
        target: "districts_page",
        actions: "initOrgFilter",
        cond: (_ctx, evt) => evt.userRole === Roles.Super_Administrator
      },
      {
        target: "district_admins_page",
        actions: "initOrgFilter",
        cond: (_ctx, evt) => evt.userRole === Roles.District_Admin
      },
      {
        target: "school_admins_page",
        actions: "initOrgFilter",
        cond: (_ctx, evt) => evt.userRole === Roles.School_Admin
      },
      {
        target: "classes_page",
        actions: "initOrgFilter",
        cond: (_ctx, evt) => evt.userRole === Roles.Teacher
      }
    ]
  }
}
